import React from 'react';

// ExternalLinkRefresher will refresh the page to ensure a hard redirect for the user. Use for route handlers that are not served by this app.
export default function ExternalLinkRefresher() {
	window.location.reload();
	return <div>If you're reading this, press the refresh button in your browser to reload the page and try again.</div>;
}
